module.exports = __webpack_public_path__ + "img/cancel.8320c544.svg";